import { render } from "./CIS-Resource-CaseStudy.vue?vue&type=template&id=73d2c8e7&scoped=true"
import script from "./CIS-Resource-CaseStudy.vue?vue&type=script&lang=js"
export * from "./CIS-Resource-CaseStudy.vue?vue&type=script&lang=js"

import "./CIS-Resource-CaseStudy.vue?vue&type=style&index=0&id=73d2c8e7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d2c8e7"]])

export default __exports__